export const USER_THIRD_PARTY_INTEGRATION_TOKENS_EXPIRED = 'user-third-party-integrations-errors.appTokensExpired'
